import LineageListPresenter from '../../components/setup/LineageList';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import {fetchSettingsList} from "../../actions/settings";
import {fetchObjectList} from "../../actions/objectList";
import {isUndefined} from "../../utils/JsObjectHelper";


const getLineageSettingsList = (settingsList, objectList) => {
    if (!isUndefined(settingsList) && settingsList.getState().isDone() && !isUndefined(objectList) && objectList.getState().isDone()) {
        let setList = settingsList.getData().filter(eT => eT.id === "lineage");
        let objList = objectList.getData();

        setList.forEach(element => {
            let objNameList = element.value.entryTypes.map(eT => { 
                return (isUndefined(objList.find(obj=>obj.type === eT)) ? eT : objList.find(obj=>obj.type === eT).name);
            });
    
            element.value.entryTypesNameList = objNameList;
        });

        return setList;
    } else {
        return null;
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        lineageSettingsList: getLineageSettingsList(state.settingsList, state.objectList)
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onMount() {
            dispatch(fetchObjectList());
            dispatch(fetchSettingsList(true));
        },
    }
};

const LineageList = connect(
    mapStateToProps,
    mapDispatchToProps
)(LineageListPresenter);

export default withRouter(LineageList);